module.exports = __webpack_public_path__ + "img/brde-acate.f894bf00.png";